import { Status, Wrapper } from '@googlemaps/react-wrapper'

import ErrorBox from 'components/ErrorBox'

import { continentalUnitedStatesBounds } from 'utils/locationHelpers'

import * as T from 'types'

import Marker from './CustomMarker'
import Map from './Map'

const render = (status: Status) => {
  if (status === Status.FAILURE) {
    return <ErrorBox error="Failed to load Google Maps" />
  }

  // this is the loading state, we may want to show a loading indicator in the future
  // but for now it seems very very fast so the result is just a blinking on the screen
  return <div />
}

interface GoogleMapProps {
  onClick?: (e: google.maps.MapMouseEvent) => void
  onIdle?: (map: google.maps.Map) => void
  onZoomChanged?: (zoom: number) => void
  onBoundsChanged?: (map: google.maps.Map) => void
  onMarkerClick: (payload: T.IListing) => void
  onMarkerHover: (payload: T.IListing) => void
  markers?: T.IListing[]
  center: google.maps.LatLngLiteral
  zoom: number
  apiKey: string
  hoveredMarkerId?: string
}

const GoogleMap = ({
  apiKey,
  onClick,
  onIdle,
  onBoundsChanged,
  onZoomChanged,
  zoom,
  center,
  markers,
  onMarkerClick,
  onMarkerHover,
  hoveredMarkerId,
}: GoogleMapProps) => (
  <Wrapper
    apiKey={apiKey}
    render={render}
  >
    <Map
      center={center}
      zoom={zoom}
      minZoom={7}
      maxZoom={18}
      onClick={onClick}
      onIdle={onIdle}
      onBoundsChanged={onBoundsChanged}
      onZoomChanged={onZoomChanged}
      fullscreenControl={false}
      streetViewControl={false}
      mapTypeControl={false}
      clickableIcons={false}
      zoomControl
      zoomControlOptions={{
        position: google.maps.ControlPosition.LEFT_TOP,
      }}
      restriction={{
        latLngBounds: continentalUnitedStatesBounds,
        strictBounds: false,
      }}
    >
      {markers?.map(marker => (
        <Marker
          key={marker._id}
          listing={marker}
          type={zoom > 9 ? 'price' : 'circle'}
          onClick={onMarkerClick}
          onHover={onMarkerHover}
          hoverActive={marker._id === hoveredMarkerId}
        />
      ))}
    </Map>
  </Wrapper>
)

export default GoogleMap
